import {get} from 'lodash';
import {CONTENT_LOCALE, LOCALE} from '../constants';
import {defaultLocaleSelector} from '../../org/selectors';

export const contentLocaleSelector = (state) => {
    return get(state, [LOCALE, CONTENT_LOCALE], defaultLocaleSelector(state));
};
